import React from 'react'

import { FormItem } from '@react/react-spectrum/Form'
import Heading from '@react/react-spectrum/Heading'
import Textfield from '@react/react-spectrum/Textfield'
import MediaUpload from 'components/MediaUpload'
import ColorInput from 'components/ColorInput'

export default function ({ branding, project, onChange, disabled }) {
  return (
    <>
      <section>
        <Heading size='4'>Logo</Heading>

        <MediaUpload
          type='image'
          value={branding.logo}
          heading='Drag and Drop'
          onUpload={onChange('logo')}
          projectId={project?.meta?.id}
          path={'branding-logo'}
          withTextfield={true}
          disabled={disabled}
        />
      </section>

      <section>
        <Heading size='4'>Header</Heading>

        <FormItem label='Background Color'>
          <ColorInput
            placeholder='Background Color'
            name='mainNavBackgroundColor'
            value={branding.mainNavBackgroundColor}
            onChange={onChange('mainNavBackgroundColor')}
            disabled={disabled}
          />
        </FormItem>

        <FormItem label='Header Text Color'>
          <ColorInput
            placeholder='Header Text Color'
            name='headerTextColor'
            value={branding.headerTextColor}
            onChange={onChange('headerTextColor')}
            disabled={disabled}
          />
        </FormItem>

        <FormItem label='Font'>
          <Textfield
            placeholder='Font'
            name='headingFont'
            value={branding.headingFont}
            onChange={onChange('headingFont')}
            disabled={disabled}
          />
        </FormItem>
      </section>

      <section>
        <Heading size='4'>Main Panel</Heading>
        <FormItem label='Background Color'>
          <ColorInput
            placeholder='Background Color'
            name='backgroundColor'
            value={branding.backgroundColor}
            onChange={onChange('backgroundColor')}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label='Text Color'>
          <ColorInput
            placeholder='Text Color'
            name='primaryTextColor'
            value={branding.primaryTextColor}
            onChange={onChange('primaryTextColor')}
            disabled={disabled}
          />
        </FormItem>

        <FormItem label='Font'>
          <Textfield
            placeholder='Font'
            name='bodyFont'
            value={branding.bodyFont}
            onChange={onChange('bodyFont')}
            disabled={disabled}
          />
        </FormItem>
      </section>
    </>
  )
}
